import httpClient from '@/api/httpClient';

export const getPromoCodeDataOrValidatePromoCode = (treatmentId, promoCode, country) =>
  httpClient.get(`/api/webShop/promoCode/applyingData/${treatmentId}/${promoCode}/${country}`);
